import { Fragment } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requireAuth } from "@/common/routes/requireAuth";
import { titleTagSuffix } from "@/common/constants";
import { Helmet } from "@/common/components/Helmet";
import PlanController from "@/pages/organizations/detail/plan";

export const Route = createFileRoute("/app/organizations/$organizationId/plan")({
  beforeLoad: ({ context }) => {
    requireAuth(context);
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Fragment>
      <Helmet>
        <title>Action Plan{titleTagSuffix}</title>
        <meta property="og:title" content={`Action Plan`} />
      </Helmet>
      <PlanController />
    </Fragment>
  );
}
